export const GLOBAL_MSG = 'GLOBAL_MSG';